/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
import { get } from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { setGlobalAlert } from '../../../../actions/offer.actions';
import { ACTIONS } from '../../../../utils/constants';
import { ContentApprovalBadges, UserContentCards } from '../components/ContentApprovalComponents';
import DraftSidePane from '../components/DraftSidePane';
import axios from '../../../../utils/axiosConfig';
import Loader from '../../../../shared/components/Loader/Loader';
import { INFLUENCERS_ENDPOINTS } from '../../../../config/api';
import Pagination from '../../../../../frontend/components/components/utils/Pagination';
import i18n from '../../../../utils/i18n';

export const showAlertOffer = ({
  success,
  action,
  dispatch
}) => {
  if (success === undefined) return;

  document.querySelector('body').scrollTo({ top: 0, behavior: 'smooth' });
  let alert = null;
  let variant = 'success';
  if (success) {
    switch (action) {
      case ACTIONS.CREATE:
        alert = <React.Fragment>
          <i className="icon fal fa-check-circle"></i>
          {i18n.t('influencers.pages.campaign.other.saved_successfully')}
        </React.Fragment>;
        break;
      case ACTIONS.DELETE:
        alert = <React.Fragment>
          <i className="icon fal fa-check-circle"></i>
          {i18n.t('influencers.pages.campaign.other.deleted_successfully')}
        </React.Fragment>;
        break;
      case ACTIONS.UPDATE:
        alert = <React.Fragment>
          <i className="icon fal fa-check-circle"></i>
          {i18n.t('influencers.pages.campaign.other.updated_successfully')}
        </React.Fragment>;
        break;
    }
  } else {
    alert = <React.Fragment>
      <i className="icon fal fa-exclamation-circle"></i>
      {i18n.t('influencers.pages.campaign.other.saved_error')}
    </React.Fragment>;
    variant = 'danger';
  }
  dispatch(setGlobalAlert({
    content: alert,
    variant,
    shouldUpdateOffer: true
  }));
};

const DraftsSection = ({
  offer,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [state, setState] = useState({
    userPostDrafts: [],
    approvedDrafts: [],
    needsReviewDrafts: [],
    rejectedDrafts: [],
    statusDrafts: {
      rejected: 0,
      accepted: 0,
      needs_review: 0,
      accepted_but: 0
    },
    draftSidePane: {
      render: false,
      open: false,
      post: null,
      status: null,
    },
    totalPages: 1,
    currentPage: 1,
    loading: false
  });

  useEffect(() => { loadUserPostDrafts(state.currentPage) }, []);

  const loadUserPostDrafts = (page) => {
    setState({ ...state, loading: true });

    axios.get(
      INFLUENCERS_ENDPOINTS.USER_POST_DRAFTS.GET(
        { 
          offer_id: offer.id,
          page: page
        }
      )
    ).then(({ data }) => {
      const {
        user_post_drafts,
        rejected_count,
        accepted_count,
        needs_review_count,
        accepted_but_count,
        total_pages,
        current_page
      } = data;

      const approvedDrafts = user_post_drafts.filter(upd => ['accepted', 'accepted_but'].includes(upd.am_review_status));
      const needsReviewDrafts = user_post_drafts.filter(upd => !['rejected', 'accepted_but', 'accepted'].includes(upd.am_review_status));
      const rejectedDrafts = user_post_drafts.filter(upd => upd.am_review_status == 'rejected');

      setState({
        ...state,
        loading: false,
        userPostDrafts: user_post_drafts,
        approvedDrafts: approvedDrafts,
        needsReviewDrafts: needsReviewDrafts,
        rejectedDrafts: rejectedDrafts,
        statusDrafts: {
          rejected: rejected_count,
          accepted: accepted_count,
          needs_review: needs_review_count,
          accepted_but: accepted_but_count
        },
        totalPages: total_pages,
        currentPage: current_page || 1
      });
    }).catch((e) => {
      console.error(e);
      setState({ ...state, loading: false });
    });
  };

  const changePage = useCallback((page, type) => {
    loadUserPostDrafts(page);
  }, [state]);

  const onEditContent = useCallback((draft, status) => {
    toggleSidePane({
      open: true,
      post: draft,
      status,
      sidePane: 'draftSidePane'
    });
  });


  /**
     * @param {boolean} open If side pane is open or not
     * @param {boolean} render If side pane should render or not,
     * this is for when the side pane is created but not opened
     */
  const toggleSidePane = useCallback(({
    open,
    render = true,
    success = undefined,
    post = null,
    status,
    action = ACTIONS.CREATE,
    sidePane = 'otherDeliverablesSidePane'
  }) => {
    document.body.style.overflow = open ? 'hidden' : 'unset';
    setState({
      ...state,
      [sidePane]: {
        open,
        render,
        post,
        status,
      }
    });
    showAlertOffer({ success, action, dispatch });
  }, [state]);

  const Section = useCallback(({ name, drafts, type = '' }) => (
    <React.Fragment>
      {state[`${type}Loading`] ?
        <Loader loading={state.loading} /> :
        <React.Fragment>
          <Col xs={12}>
            <h4 className='mb-4'>
              {name}
            </h4>
            <UserContentCards
              userContent={drafts}
              userContentType="userPostDraft"
              onEdit={onEditContent} />
          </Col>
        </React.Fragment>
      }
    </React.Fragment>
  ), [state]);

  return <React.Fragment>
    <Row className='mb-4-5'>
      <Col xs="12">
        {t('influencers.pages.campaign.posting_phase.good_to_go')}
      </Col>
    </Row>
    <Row>
      <ContentApprovalBadges statusDrafts={state.statusDrafts} />
    </Row>
    <Row className="mt-5">
      <Col xs="12" className="text-center mb-4">
        <Pagination
          currentPage={state.currentPage}
          lastPage={state.totalPages}
          fetchData={changePage}
        />
      </Col>
      {/* If all content has been approved show the message below */}
      {
        state.approvedDrafts.length ? <Section
          name={t('influencers.pages.campaign.posting_phase.approved_to_post')}
          drafts={state.approvedDrafts} type='approved' /> : null
      }
      {state.rejectedDrafts.length ? <Col xs={12}>
        <hr className='mt-0 mb-4-5' />
      </Col> : null}
      {
        state.rejectedDrafts.length ? <Section
          name={t('influencers.pages.campaign.posting_phase.not_approved_to_post')}
          drafts={state.rejectedDrafts} type='rejected' /> : null
      }
      {state.needsReviewDrafts.length ? <Col xs={12}>
        <hr className='mt-0 mb-4-5' />
      </Col> : null}
      {
        state.needsReviewDrafts.length ? <Section
          name={t('influencers.pages.campaign.posting_phase.needs_review')}
          drafts={state.needsReviewDrafts} type='needsReview' /> : null
      }
      {!state.approvedDrafts.length &&
        !state.rejectedDrafts.length &&
        !state.needsReviewDrafts.length ?
        <Col xs={12}>
          <Card className="empty mb-4-5">{t('influencers.pages.campaign.no_content')}</Card>
        </Col> : null
      }
      {<Col xs="12" className="text-center mt-4">
        <Pagination
          currentPage={state.currentPage}
          lastPage={state.totalPages}
          fetchData={changePage}
        />
      </Col>}
      {state.draftSidePane.render && <DraftSidePane
        open={state.draftSidePane.open}
        draft={state.draftSidePane.post}
        status={state.draftSidePane.status}
        readOnly={true}
        onRequestClose={() =>
          toggleSidePane({
            open: false,
            post: state.draftSidePane.post,
            sidePane: 'draftSidePane'
          })
        }
        onAfterClose={(success, action = ACTIONS.CREATE) =>
          toggleSidePane({
            open: false,
            render: false,
            success,
            action,
            sidePane: 'draftSidePane'
          })
        }
      />}
    </Row>
  </React.Fragment>;
};

export default DraftsSection;